import React from 'react'

import { Colorway, Select } from '@fourthwall/components'

import type { OfferImagesFilter } from '../../types'

export const OfferImagesFilters = ({
  filters,
  onColorFilterSort,
}: {
  filters: OfferImagesFilter[]
  onColorFilterSort: (oldIndex: number, newIndex: number) => void
}) => {
  return filters.map((filter) => {
    if (filter.type === 'COLOR') {
      return (
        <Colorway
          colors={filter.options.map((option) => ({ ...option, value: option.color }))}
          activeColor={filter.value}
          onSortChange={filter.tag === 'COLOR' ? onColorFilterSort : undefined}
          onChange={(option) => filter.onChange(option.label)}
          isDraggable
        />
      )
    }

    return (
      <Select
        label={filter.label}
        options={filter.options}
        value={filter.value}
        onValueChange={filter.onChange}
      />
    )
  })
}
